
import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { PerkField } from './PerkField';
import { PerksFormData } from '@/hooks/usePerksForm';

interface PerksFormFieldsProps {
  form: UseFormReturn<PerksFormData>;
}

export const PerksFormFields: React.FC<PerksFormFieldsProps> = ({ form }) => {
  return (
    <div className="space-y-6">
      <PerkField 
        form={form}
        fieldName="perk1"
        label="Perk 1"
        placeholder="E.g., Flexible working hours"
        showDescription={true}
      />
      
      <PerkField 
        form={form}
        fieldName="perk2"
        label="Perk 2"
        placeholder="E.g., Health insurance"
      />
      
      <PerkField 
        form={form}
        fieldName="perk3"
        label="Perk 3"
        placeholder="E.g., Professional development budget"
      />
      
      <PerkField 
        form={form}
        fieldName="perk4"
        label="Perk 4"
        placeholder="E.g., Remote work options"
      />
      
      <PerkField 
        form={form}
        fieldName="perk5"
        label="Perk 5"
        placeholder="E.g., Team building events"
      />
    </div>
  );
};
